import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { forwardRef, type ReactNode } from 'react';

import { Check } from '@air/next-icons';
import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const checkbox = tailwindVariants({
  base: 'rounded-2 border border-grey-8 bg-grey-1 radix-state-checked:border-blue-9 radix-state-checked:bg-blue-9 radix-state-checked:text-white hover:radix-state-checked:bg-blue-10 disabled:border-grey-5 disabled:bg-grey-2 disabled:radix-state-checked:border-grey-7 disabled:radix-state-checked:bg-grey-7',
  defaultVariants: {
    size: 'medium',
  },
  variants: {
    size: {
      'extra-large': 'h-6 w-6',
      large: 'h-5 w-5',
      medium: 'h-4 w-4',
      small: 'h-3 w-3',
    },
  },
});

export type CheckboxVariants = VariantProps<typeof checkbox>;

export type CheckboxProps = RadixCheckbox.CheckboxProps &
  CheckboxVariants & {
    renderIndicator?: (props: { checked: RadixCheckbox.CheckboxProps['checked'] }) => ReactNode;
  };

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
  ({ checked, className, size, renderIndicator, ...restOfProps }, forwardedRef) => {
    return (
      <RadixCheckbox.Root
        checked={checked}
        className={checkbox({ class: className, size })}
        ref={forwardedRef}
        {...restOfProps}
      >
        <RadixCheckbox.Indicator>{renderIndicator ? renderIndicator({ checked }) : <Check />}</RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
    );
  },
);

Checkbox.displayName = 'Checkbox';
